import React from "react";
import { REQUEST_STATUS } from "./constants";
import TickIcon from "../../Common/Svgs/TickIcon";
import TrikeIcon from "../../Common/Svgs/TrikeIcon";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import PendingIcon from "../../Common/Svgs/PendingIcon";
import { RENTAL_STATUS } from "../Rentals/constant";

export const getRequestStatus = (requestStatus) => {
  if (+requestStatus === REQUEST_STATUS.PENDING) {
    return (
      <div className="flex items-center h-[26px] w-[90px] py-1 px-2 gap-x-1 bg-warning-10 rounded-md">
        <PendingIcon size={16} className="text-warning" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-warning">
          Pending
        </p>
      </div>
    );
  }

  if (+requestStatus === REQUEST_STATUS.REJECTED) {
    return (
      <div className="flex items-center h-[26px] w-[93px] py-1 px-2 gap-x-1 bg-alert-10 rounded-md">
        <CloseIcon className="w-4 h-4 stroke-alert-red" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-alert-red">
          Rejected
        </p>
      </div>
    );
  }

  if (requestStatus === REQUEST_STATUS.ACCEPTED) {
    return (
      <div className="flex items-center h-[26px] w-[112px] py-1 px-2 gap-x-1 bg-green-10 rounded-md">
        <TickIcon size={16} className="text-green" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-green">
          Accepted
        </p>
      </div>
    );
  }

  if (requestStatus === REQUEST_STATUS.ASSIGN_TRIKE) {
    return (
      <div className="flex items-center h-[26px] w-[112px] py-1 px-2 gap-x-1 bg-green rounded-md">
        <TickIcon size={16} className="text-background-white" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-background-white">
          Assign Trike
        </p>
      </div>
    );
  }

  if (requestStatus === REQUEST_STATUS.TRIKE_ASSIGNING_COMPLETED) {
    return (
      <div className="flex items-center h-[26px] w-[128px] py-1 px-2 gap-x-1 bg-green-10 rounded-md">
        <TrikeIcon size={16} className="text-green" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-green">
          Trike Assigned
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center h-[26px] w-[93px] py-1 px-2 gap-x-1 bg-alert-10 rounded-md">
      <CloseIcon className="w-4 h-4 stroke-alert-red" />
      <p className="font-poppins font-medium text-xs leading-[18px] text-alert-red">
        Rejected
      </p>
    </div>
  );
};

export const getRentalStatus = (requestStatus) => {
  // this means request is accepted but you need to assign trike and batteries
  if (requestStatus === RENTAL_STATUS.ASSIGN_TRIKE) {
    return (
      <div className="flex items-center h-[26px] w-[98px] py-1 px-2 gap-x-1 bg-green-10 rounded-md">
        <TickIcon size={16} className="text-green" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-green">
          Accepted
        </p>
      </div>
    );
  }

  if (+requestStatus === RENTAL_STATUS.PENDING) {
    return (
      <div className="flex items-center h-[26px] w-[90px] py-1 px-2 gap-x-1 bg-warning-10 rounded-md">
        <PendingIcon size={16} className="text-warning" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-warning">
          Pending
        </p>
      </div>
    );
  }

  if (+requestStatus === RENTAL_STATUS.REJECTED) {
    return (
      <div className="flex items-center h-[26px] w-[93px] py-1 px-2 gap-x-1 bg-alert-10 rounded-md">
        <CloseIcon className="w-4 h-4 stroke-alert-red" strokeWidth={2} />
        <p className="font-poppins font-medium text-xs leading-[18px] text-alert-red">
          Rejected
        </p>
      </div>
    );
  }

  if (+requestStatus === RENTAL_STATUS.DRIVER_CANCEL) {
    return (
      <div className="flex items-center h-[26px] w-[98px] py-1 px-2 gap-x-1 bg-[#B1B1B1] rounded-md">
        <CloseIcon
          className="w-4 h-4 stroke-background-white"
          strokeWidth={2}
        />
        <p className="font-poppins font-medium text-xs leading-[18px] text-background-white">
          Cancelled
        </p>
      </div>
    );
  }

  // this means request has been accepted and trike is also assigned
  if (+requestStatus === RENTAL_STATUS.APPROVED) {
    return (
      <div className="flex items-center h-[26px] w-[144px] py-1 px-2 gap-x-1 bg-green rounded-md">
        <TickIcon size={16} className="text-background-white" />
        <p className="font-poppins font-medium text-xs leading-[18px] text-background-white whitespace-nowrap">
          Vehicle Assigned
        </p>
      </div>
    );
  }

  if (+requestStatus === RENTAL_STATUS.COMPLETED) {
    return (
      <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-light-grey">
        <p className="font-poppins text-xs font-medium text-dark-gray">
          Completed
        </p>
      </div>
    );
  }

  if (+requestStatus === RENTAL_STATUS.ONGOING) {
    return (
      <div className="max-w-max flex items-center px-2 h-7 rounded-md bg-yellow">
        <p className="font-poppins text-xs font-medium text-green">
          Dispatched
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center h-[26px] w-[93px] py-1 px-2 gap-x-1 bg-alert-10 rounded-md">
      <CloseIcon className="w-4 h-4 stroke-alert-red" />
      <p className="font-poppins font-medium text-xs leading-[18px] text-alert-red">
        Rejected
      </p>
    </div>
  );
};
